import React from 'react';
import { formatMessage } from 'devextreme/localization';

interface PathVersionStatusProps {
    /** True while the editor holds modifications that have not been persisted yet. */
    HasUnsavedChanges: boolean;
    /** True when the last persisted version is the published one (decided by the back, not by unsaved edits). */
    IsPublished: boolean;
}

const GREEN = '#3CC47C';
const ORANGE = '#FFA500';
const GREY = '#8A8A96';

function Badge({ icon, color, text }: { icon: string, color: string, text: string }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color, fontFamily: 'Manrope', fontSize: 13, fontWeight: 600 }}>
            <i className={`dx-icon dx-icon-${icon}`} style={{ color, fontSize: 16 }}></i>
            <span>{text}</span>
        </div>
    );
}

/**
 * Header indicator of the path editors: is the version being edited saved, and is it published?
 * "Published" only reflects the persisted versions: unsaved edits don't turn it into "Not published",
 * only a save that makes the back create a new version does.
 */
const PathVersionStatus: React.FC<PathVersionStatusProps> = ({ HasUnsavedChanges, IsPublished }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }} data-testid="path-version-status">
            {HasUnsavedChanges
                ? <Badge icon="warning" color={ORANGE} text={formatMessage('PathVersion_Unsaved')} />
                : <Badge icon="check" color={GREEN} text={formatMessage('PathVersion_Saved')} />}
            {IsPublished
                ? <Badge icon="check" color={GREEN} text={formatMessage('PathVersion_Published')} />
                : <Badge icon="clock" color={GREY} text={formatMessage('PathVersion_NotPublished')} />}
        </div>
    );
};

export default PathVersionStatus;
